<script>
	const page = require('page');
	const _ = require('underscore');
	const model = require('model/model');
	const productService = require('services/productService');
	const assignmentService = require('services/assignmentService');
	const scrollManager = require('ui/core/scrollManager');
	const Grading = require('readworks-grading.js');
	const { assetUrl } = require('utilities/urlUtilities');
	const pubsub = require('events/pubsub');

	module.exports = {
		props: ['route-context', 'article', 'assessment', 'question-sets'],
		components: {
			'overdue-icon': require('components/overdue-icon.vue').default,
			'validated-textarea': require('components/validated-textarea.vue').default,
			'vocabulary-image-list': require('components/vocabulary-image-list.vue').default,
			'text-to-speech-player-simple': require('components/text-to-speech-player-simple.vue').default
		},
		data: function () {
			return {
				questionSetId: '',
				student: null,
				product: {},
				studentAssessment: null,
				questions: [],
				openResponseQuestions: [],
				multipleChoiceQuestions: [],
				openResponseQuestionsAllGraded: false,
				multipleChoiceQuestionsCorrect: 0,
				multipleChoicePercentCorrect: 0,
				openResponseQuestionsCorrect: 0,
				openResponsePercentCorrect: 0,
				totalCorrect: 0,
				percentTotalCorrect: 0,
				firstUnansweredQuestion: null
			};
		},
		modelData: {
			student: 'uid'
		},
		mounted() {
			var self = this;

			self.$watch('questionSetId', _.bind(self.setupQuestionSet, self));
			self.$watch('studentAssessment', _.bind(self.setupQuestionSet, self));

			this.own(
				model.change('student', _.bind(self.loadAssessmentForStudent, self)),
				model.change('qset', function (id) {
					self.loadAssessmentForStudent();
					self.setQuestionSet(id);
				})
			);

			// when submission state changes in the parent, reload this assessment
			// (this is to catch the case where a revise reassignment takes place)
			self.$watch(
				function () {
					return this.assessment.students[self.uid] && this.assessment.students[self.uid].submitted;
				}.bind(this),
				function () {
					self.loadAssessmentForStudent();
				}.bind(this)
			);

			pubsub.subscribe('assessment-needs-reload', function (isRedo) {
				// for redo student data is gone, so we need to go back to classresults
				// for revise, we watch this.assessment.students[uid].submitted
				// so that we invoke loadAssessment after the parent component's assessment
				// is reloaded (since we use some of the class assessment data in this view
				// as well)
				if (isRedo) {
					model.set('resultsTab', 'classresults');
					model.set('student', '');
				}

				return true;
			});
		},
		methods: {
			scrollToNote: function (index) {
				scrollManager($('[data-note=' + index + ']'), {
					duration: 500,
					priority: 0
				});
			},
			scrollToFirstUngradedQuestion: function () {
				var self = this;

				var firstTeacherGraded = null;
				var foundUngraded = false;

				self.student.answers[self.questionSetId].forEach(function (q, idx) {
					var reportQuestion = self.questions[idx];

					if (!Grading.questionTypeIsScorable(q.questionType)) {
						if (!firstTeacherGraded) {
							firstTeacherGraded = reportQuestion;
						}

						if (!foundUngraded && typeof q.score === 'undefined') {
							reportQuestion.a.navigateToStudentGrading();
							foundUngraded = true;
						}
					}
				});

				if (!foundUngraded && firstTeacherGraded) {
					firstTeacherGraded.a.navigateToStudentGrading();
				}
			},
			getNote: function (questionInfo) {
				var q = this.assessment.students[this.uid].answers[questionInfo.qsid];

				for (var i = 0, l = q.length; i < l; i++) {
					if (q[i].qid === questionInfo.qid) {
						return q[i].teacherNote;
					}
				}

				return false;
			},
			saveGeneralNote: function (event, qsid) {
				if (event && qsid) {
					let aid = this.routeContext.params.assignmentId;
					let uid = this.uid;
					let f = event.target.value;
					this.assessment.students[uid].generalNotes[qsid] = f;
					assignmentService.giveGeneralFeedback({
						aid,
						uid,
						qsid,
						f
					});
				}
			},
			setQuestionSet: function (qsId) {
				this.questionSetId = qsId || null;
				if (!this.questionSetId && this.questionSets && this.questionSets.length) {
					this.questionSetId = this.questionSets[0].id;
				}
			},
			/**
			 * [throttle description]
			 * @param  {[type]} function( [description]
			 * @return {[type]}           [description]
			 */
			loadAssessmentForStudent() {
				if (!this.uid) {
					this.studentAssessment = null;
					this.student = null;

					if (model.get('resultsTab') === 'studentresults') {
						// This page is invalid with no UID
						model.set('resultsTab', 'classresults');
						model.set('student', '');
					}
					return;
				}

				const student = this.assessment.students[this.uid];
				student.uid = this.uid;

				this.student = student;

				const currentProduct = this.product;
				const pid = this.assessment.productId;

				if (!currentProduct || currentProduct.id !== pid) {
					productService.get(pid).then(product => {
						this.product = product;
					});
				}

				if (student.hasWorkspace) {
					const params = {
						classCode: this.routeContext.params.classCode,
						assignmentId: this.routeContext.params.assignmentId,
						uid: this.uid
					};

					assignmentService.teacherGetSingleStudentAssignmentResults(params).then(assessment => {
						this.studentAssessment = assessment;
					});
				} else {
					this.studentAssessment = {};
				}
			},
			setupQuestionSet: function () {
				var qs,
					report,
					self = this;

				if (!self.studentAssessment) {
					return;
				}

				if (self.questionSetId && self.product && self.product.questionSets) {
					qs = self.product.questionSets[self.questionSetId];
				}
				var questions = [];
				if (qs) {
					var uid = self.studentAssessment.uid;
					var qsAnswers = {};
					if (self.studentAssessment.scoring && self.studentAssessment.scoring.questionSets) {
						qsAnswers = $.extend(true, {}, self.studentAssessment.scoring.questionSets[qs.qsid]);
					}

					let qsetQuestions = self.product.getQuestions(qs.qsid, _.contains(self.assessment.options.expressqs || [], qs.qsid));

					_.each(qsetQuestions, function (q, qIdx) {
						q.qsid = qs.qsid;
						q.assignmentId = self.routeContext.params.assignmentId;

						var a = qsAnswers[q.qid];
						if (a) {
							a.student = self.student;
							a.navigateToStudentGrading = function (note) {
								page('/assignment/' + self.routeContext.params.classCode + '/' + self.routeContext.params.assignmentId + '/questions');

								model.set({
									assessmentTab: 'results',
									resultsTab: 'questions',
									qset: self.questionSetId,
									student: uid,
									q: typeof qIdx === 'number' ? qIdx + 1 : '',
									noteId: note,
									selectedQID: q.qid
								});
							};

							// _.each(a.subQuestions, function(sq, sqId) {

							// 	sq.navigateToStudentGrading = function(note) {
							// 		page('/assignment/' + self.routeContext.params.classCode +
							// 			'/' + self.routeContext.params.assignmentId +
							// 			'/questions?highlightQuestion=' + q.qid + '&highlightStudent=' + uid + '&note=' + note +
							// 			'&highlightSubQuestion=' + sqId);

							// 		model.set({
							// 			'assessmentTab': 'results',
							// 			'resultsTab': 'questions',
							// 			'qset': self.questionSetId,
							// 			'student': uid,
							// 			'q': (typeof qIdx === 'number') ? qIdx + 1 : ''
							// 		});
							// 	};
							// });
						}
						questions.push({
							q: q,
							a: a
						});
					});

					report = Grading.studentAssessmentSummary(uid, qs.qsid, qsAnswers, self.product, self.assessment.options);
				} else {
					report = Grading.studentAssessmentSummary(null, null, null, null, null);
				}
				self.questions = questions;

				_.each(report, function (v, k) {
					self[k] = v;
				});
			},
			assetUrl(url) {
				return assetUrl(url);
			}
		},
		computed: {
			hasNote: function () {
				var answers = this.assessment.students[this.uid].answers[this.questionSetId];

				for (var i = 0, l = answers.length; i < l; i++) {
					if (answers[i].teacherNote) {
						return true;
					}
				}

				return false;
			},
			showTts: function () {
				return this.assessment.options.au;
			}
		}
	};
</script>
<template>
	<div class="wrapper student-results">
		<section
			v-if="student"
			class="question-set student-results-question-set">
			<header class="question-set-header -student-assessment grid">
				<div class="row">
					<div class="columns large-8 small-12">
						<h2 class="print-only">
							{{ product.title }}
							<template v-if="product.productType === 'PT'"> - Paired Text </template>
						</h2>
						<h2>
							{{ product.questionSets && product.questionSets[questionSetId].title }}
						</h2>
						<div class="padding-bottom-medium assignment-meta">
							<template v-if="student.submitted">
								Submitted
								<template v-if="studentAssessment && studentAssessment.timeSubmitted">
									{{ studentAssessment.timeSubmitted | date }} at {{ studentAssessment.timeSubmitted | time }}
								</template>
							</template>
							<template v-if="!student.submitted"> Unsubmitted </template>
							<overdue-icon v-if="student.overdue"></overdue-icon>
							<template v-if="student.submitted">
								<template v-if="multipleChoiceQuestions.length > 0">
									<br />
									Multiple Choice: {{ multipleChoiceQuestionsCorrect }}/{{ multipleChoiceQuestions.length }} ({{ multipleChoicePercentCorrect }}%)
								</template>
								<template v-if="openResponseQuestions.length > 0">
									<br />
									<template v-if="openResponseQuestionsAllGraded">
										Written Response: {{ openResponseQuestionsCorrect }}/{{ openResponseQuestions.length }} ({{ openResponsePercentCorrect }}%)
									</template>
									<template v-if="!openResponseQuestionsAllGraded">
										<div>Written Response: Needs Grading</div>
										<div
											v-on:click="scrollToFirstUngradedQuestion()"
											class="button -reverse"
											style="float: none; margin-left: 0">
											Grade Assignment
										</div>
									</template>
								</template>
								<template v-if="openResponseQuestionsAllGraded && questions.length > 0">
									<br />
									Total: {{ totalCorrect }}/{{ openResponseQuestions.length + multipleChoiceQuestions.length }} ({{ percentTotalCorrect }}%)
								</template>
							</template>
						</div>
					</div>
					<div
						class="teacher-feedback columns large-4 small-12"
						v-if="assessment.students && assessment.students[uid].hasWorkspace"
						:class="{
							'print-hidden': !assessment.students[uid].generalNotes[questionSetId]
						}">
						<h4>Teacher Feedback</h4>
						<validated-textarea
							class="print-hidden"
							@change.native="saveGeneralNote($event, questionSetId)"
							:disabled="!uid"
							:value="assessment.students[uid].generalNotes[questionSetId] || ''"
							:placeholder="'Add general feedback...'"
							:hide-message-bar="true"></validated-textarea>
						<div class="general-feedback-note print-only margin-left-medium margin-bottom-medium">
							{{ assessment.students[uid].generalNotes[questionSetId] }}
						</div>
						<div
							v-if="hasNote"
							class="margin-top-medium padding-bottom-medium print-hidden">
							<template v-for="(answer, answerIndex) in assessment.students[uid].answers[questionSetId]">
								<img
									v-if="answer.teacherNote"
									style="cursor: pointer"
									v-on:click="scrollToNote(answerIndex)"
									class="margin-right-small"
									:src="assetUrl('/assets/dist/images/icon-note-active-' + (answerIndex + 1) + '.svg')" />
							</template>
						</div>
					</div>
				</div>
			</header>
			<div class="question-set-questions grid">
				<div
					class="directions"
					v-if="product.questionSets && product.questionSets[questionSetId].studentIntro"
					v-html="product.questionSets[questionSetId].studentIntro"></div>
				<template v-if="product.questionSets && product.questionSets[questionSetId].studentIntroImages">
					<vocabulary-image-list
						:images="product.questionSets[questionSetId].studentIntroImages"
						:word="product.questionSets[questionSetId].vocabularyWord">
					</vocabulary-image-list>
				</template>
				<div
					v-for="(q, index) in questions"
					:key="q.q.qid"
					:data-qid="q.q.qid"
					:data-note="index"
					v-bind:class="{ 'show-answer': q.a, '-submitted': student.submitted, row: true, 'question-row': true }">
					<div class="question-set-item columns large-8 small-12">
						<question
							:q="q.q"
							:index="index + 1"
							:submitted-answer="q.a"
							:qsid="selectedSetId"
							:show-tts="showTts">
						</question>
					</div>
					<div class="question-feedback columns large-4 small-12">
						<div
							v-if="getNote(q.q)"
							class="feedback-body margin-top-medium margin-bottom-medium">
							<img
								class="print-hidden"
								:src="assetUrl('/assets/dist/images/icon-note-active-' + (index + 1) + '.svg')" />
							<span class="feedback-label print-only"> Feedback: </span>
							<span
								class="feedback-note"
								@click="q.a.navigateToStudentGrading(q.q.qid)"
								style="font-weight: normal; cursor: pointer">
								{{ getNote(q.q) }}
							</span>
						</div>
						<div
							v-if="!getNote(q.q) && student.submitted"
							class="print-hidden">
							<img
								v-on:click="q.a.navigateToStudentGrading(q.q.qid)"
								style="cursor: pointer"
								:src="assetUrl('/assets/dist/images/icon-note.svg')" />
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>
<style lang="scss">
	@import 'config/colors';
	@import 'mixins/flexbox';

	.student-results {
		section.question-set.student-results-question-set {
			.validated-textarea {
				min-height: 3rem;
				width: 100%;
				font-size: 0.75rem;
				border: none;
			}

			.question-set-header {
				border-bottom: 1px solid $c-grey;
			}
		}
	}

	@media print {
		.student-results {
			.question-set {
				.question-set-header {
					h2 {
						font-size: 1.75em;
					}

					.assignment-meta {
						margin-left: 1rem;
					}

					.teacher-feedback {
						padding-left: 0;

						h4 {
							font-size: 1.75em;
							font-weight: normal;
							margin-top: 0;
							margin-bottom: 0;
						}
					}
				}

				.question-set-questions {
					.question-set-item {
						page-break-inside: avoid;
						margin-bottom: 0;

						.question > p {
							margin: 0.5rem 0;
						}

						> .answer {
							li {
								color: $c-slate-dark !important;

								& > * {
									color: $c-slate-dark !important;
								}

								&.correct {
									color: #000 !important;

									& > * {
										color: #000 !important;
									}
								}

								&.chosen {
									&:before {
										width: initial;
										font-size: 1rem;
									}

									&.incorrect {
										font-weight: normal;
									}
								}
							}

							.written-answer-real {
								margin-left: 2em;

								& > * {
									color: $c-slate-dark !important;

									> * {
										color: $c-slate-dark !important;
									}
								}
							}

							.written-answer-submitted {
								margin-left: 2em;
								font-weight: normal;

								&:before {
									position: absolute;
									left: -1.5rem;
									font-size: 0.8rem;
									top: 0px;
									color: #fff !important;
									background-color: $c-black !important;
									border-radius: 5px;
								}

								&.-grade-0:before,
								&.-grade-100:before {
									position: absolute;
									left: -1.5rem;
									font-size: 1rem;
									top: 2px;
									color: #000 !important;
									background-color: transparent !important;
								}
							}

							&.image-answer-answer > .grid {
								@include flexbox();

								> .grid-col-6 {
									flex: 1;
									margin: 1rem;
									border-color: transparent;
									overflow: inherit;

									&.chosen {
										border-color: #000;

										&:before {
											font-size: 1rem;
											top: 0.25rem;
											left: -2rem;
										}
									}

									&.incorrect > * {
										opacity: 0.3;
									}
								}
							}
						}
					}

					.question-feedback {
						padding-left: 0;

						.feedback-body {
							background-color: $c-grey !important;
							padding: 0.25rem;
						}

						.feedback-label {
							display: inline-block;
							font-weight: 700;
						}
					}
				}
			}
		}
	}
</style>
